module.exports = __webpack_public_path__ + "static/media/due-port-logogif.1ba1218c.gif";